import { render, staticRenderFns } from "./PermissionPresets.vue?vue&type=template&id=b5e355ec&scoped=true"
import script from "./PermissionPresets.vue?vue&type=script&lang=js"
export * from "./PermissionPresets.vue?vue&type=script&lang=js"
import style0 from "./PermissionPresets.vue?vue&type=style&index=0&id=b5e355ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e355ec",
  null
  
)

export default component.exports